import type { ReactElement, ReactNode } from 'react'
import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip'
import { cn } from '@/lib/utils'
import './tooltip.css'

export type TooltipProps = {
  /** Visual label for sighted pointer and keyboard users. The trigger keeps its own accessible name. */
  content: ReactNode
  /** The trigger element. It must be focusable and named, for example an IconButton. */
  children: ReactElement
  side?: 'top' | 'bottom' | 'left' | 'right'
  /** Portal target, for example an active fullscreen root. Defaults to the document body. */
  container?: HTMLElement | null
  /** How long the pointer rests on the trigger before it shows, in milliseconds. Focus shows it at once. Defaults to 600. */
  delay?: number
  /** Classes for the tooltip surface, for example an exception over video. */
  className?: string
}

/** Shows a short label on hover and keyboard focus. Not a substitute for an accessible name. */
export function Tooltip({ content, children, side = 'top', container, delay, className }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} delay={delay} />
      <BaseTooltip.Portal container={container ?? undefined}>
        <BaseTooltip.Positioner side={side} sideOffset={8} collisionPadding={12} className="play-tooltip-positioner">
          <BaseTooltip.Popup className={cn('play-theme play-tooltip', className)}>{content}</BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  )
}
